import { encrypt } from '@/common/securityUtils';
import { useForm } from '@/components/forms';
import { useAssignPointCategory } from '@/features/points-management/points-configuration/hooks/usePointCategoryMutations';
import { useDropdown } from '@/hooks/useDropdown';
import { useDynamicLocale } from '@/hoslog-intl/Translation';
import { z } from 'zod';
import AssignPointsFormView from './AssignPointsFormView';

const schema = z.object({
  userType: z.string().refine((value) => value !== '' && value !== 'default', {
    message: 'common.form.validation.required',
  }),
  userName: z.string().min(1, { message: 'common.form.validation.required' }),
  currentCategory: z.string().optional().default(''),
  pointCategoryId: z.string().min(1, { message: 'common.form.validation.required' }),
});

const AssignPointsFormContainer = () => {
  const { t } = useDynamicLocale();
  const form = useForm({
    schema,
    mode: 'onBlur',
    defaultValues: { userType: '', userName: '', currentCategory: '', pointCategoryId: '' },
  });
  const { mutateAsync } = useAssignPointCategory();
  const userTypeOptions = [
    {
      id: 'customer',
      label: t('userManagement.rolesAndPrivileges.tabs.customer'),
      value: encrypt('3'),
      disabled: true,
    },
    {
      id: 'club',
      label: t('userManagement.rolesAndPrivileges.tabs.club'),
      value: encrypt('4'),
      disabled: true,
    },
    {
      id: 'affiliate',
      label: t('userManagement.rolesAndPrivileges.tabs.affiliate'),
      value: encrypt('6'),
    },
  ];
  const selectedUserType = form.watch('userType');
  const selectedUserName = form.watch('userName');
  const selectedUserTypeName = userTypeOptions.find(({ value }) => value === selectedUserType)?.id;
  const { data: userOptions = [] } = useDropdown(
    'userList',
    selectedUserType,
    undefined,
    undefined,
    Boolean(selectedUserType),
  );
  const { data: currentCategoryOptions = [] } = useDropdown(
    'currentPointCategory',
    selectedUserName,
    undefined,
    selectedUserTypeName,
    Boolean(selectedUserName && selectedUserTypeName),
  );
  const currentCategoryValue = currentCategoryOptions[0]?.value;
  const { data: categoryOptions = [] } = useDropdown(
    'pointCategoryList',
    currentCategoryValue,
    undefined,
    selectedUserTypeName,
    Boolean(currentCategoryValue && selectedUserTypeName),
  );

  return (
    <AssignPointsFormView
      form={form}
      userTypeOptions={userTypeOptions}
      userOptions={userOptions}
      categoryOptions={categoryOptions}
      currentCategoryLabel={currentCategoryOptions[0]?.label ?? ''}
      onSubmit={async ({ pointCategoryId, userType, userName }) => {
        await mutateAsync({ pointCategoryId, agentType: userType, agentId: userName });
      }}
    />
  );
};

export default AssignPointsFormContainer;
